import React from "react";
import { CheckCircleIcon } from "../../asset/icons";

const RecipientTypeModal = ({ open, active, onSelect, onClose, title, options }) => {
    if (!open) return null;

    return (
        <div className="fixed inset-0 z-50">
            <div className="absolute inset-0 bg-black/40" onClick={onClose} aria-hidden="true" />
            <div
                role="dialog"
                aria-modal="true"
                className="absolute inset-x-4 md:inset-x-0 md:left-1/2 md:-translate-x-1/2 top-12 md:top-44 max-w-2xl rounded-2xl bg-white shadow-xl"
            >
                <div className="!px-8 !pt-8 !pb-8">
                    <h3 className="text-[18px] font-semibold text-[#101828] mb-6">
                        {title || "Recipient type"}
                    </h3>
                    <div className="space-y-3">
                        {(options || []).map((opt) => {
                            const checked = active === opt.id;
                            return (
                                <button
                                    key={opt.id}
                                    type="button"
                                    onClick={() => onSelect(opt.id)}
                                    className={`w-full text-left rounded-xl border transition px-4 py-4 hover:bg-[#F8F9FD] ${
                                        checked ? "border-[#6F00FF]" : "border-[#EEF0F4]"
                                    }`}
                                >
                                    <div className="flex items-center justify-between">
                                        <div className="flex gap-2 items-center">
                                            <div className="p-2 bg-[#F7F8FD] text-[#4F5372] rounded-full">
                                                {opt.icon}
                                            </div>
                                            <div>
                                                <div className="text-[15px] font-[600] text-[#101828]">
                                                    {opt.title}
                                                </div>
                                                <div className="text-[14px] text-[#4F5372]">
                                                    {opt.desc}
                                                </div>
                                            </div>
                                        </div>

                                        {checked ? (
                                            <CheckCircleIcon className="size-5" />
                                        ) : (
                                            <CheckCircleIcon className="size-5 *:fill-[#DBDFE5]" />
                                        )}
                                    </div>
                                </button>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RecipientTypeModal;
